import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RESOURCES } from 'OpsCenter/app.constants';
import { Observable } from 'rxjs/Observable';

export default function merchantService($http, RESOURCES, API_V2_HEADER, API_V3_HEADER, API_V4_HEADER) {
  function exportCustomers(merchantId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + '/customers_csv', {
      headers: {
        Accept: 'text/csv',
      },
    });
  }

  function importCustomers(merchantId, file) {
    const fd = new FormData();
    fd.append('attachment', file);
    return $http.post(RESOURCES.MERCHANT + '/' + merchantId + '/import_csv', fd, {
      transformRequest: angular.identity,
      headers: {
        'Content-Type': undefined,
      },
    });
  }

  function importCustomersV2(merchantId, file) {
    const fd = new FormData();
    fd.append('attachment', file);
    const headers = Object.assign({}, API_V2_HEADER.headers, { 'Content-Type': undefined });
    return $http.post(RESOURCES.MERCHANT + '/' + merchantId + '/import_csv', fd, {
      transformRequest: angular.identity,
      headers,
    });
  }

  // Used to retrieve the book setting that should be displayed on the merchant products page.
  function getMerchantSetting(merchantId, settingAttributeId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + '/settings?settingAttributeIds=' + settingAttributeId);
  }

  function getMerchantById(merchantId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId, API_V2_HEADER);
  }

  function getMerchants(params) {
    return $http.get(RESOURCES.MERCHANT, { params: params });
  }

  function updateMerchantStatus(merchantId, data) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + '/status', data);
  }

  function deleteAreaById(merchantId, areaId) {
    return $http.delete(RESOURCES.MERCHANT + '/' + merchantId + '/areas/' + areaId);
  }

  function updateMerchant(id, data) {
    return $http.put(RESOURCES.MERCHANT + '/' + id, data, API_V4_HEADER);
  }

  function triggerReindex(id) {
    return $http.put(RESOURCES.MERCHANT + '/' + id + '/reindex_availabilities');
  }

  function cancelAllReservations(id) {
    return $http.put(RESOURCES.MERCHANT + '/' + id + '/reservations/cancel_future');
  }

  function getMerchantProducts(id) {
    return $http.get(RESOURCES.MERCHANT + '/' + id + '/products');
  }

  function addMerchant(params) {
    return $http.post(RESOURCES.MERCHANT, params, {
      headers: API_V4_HEADER.headers,
    });
  }

  function getExternalPartnerSource(id){
    return $http.get(RESOURCES.MERCHANT + '/' + id + '/sources');
  }

  return {
    importCustomersV2,
    exportCustomers,
    importCustomers,
    getMerchantById,
    getMerchantSetting,
    deleteAreaById,
    updateMerchantStatus,
    getMerchants,
    updateMerchant,
    getMerchantProducts,
    addMerchant,
    triggerReindex,
    cancelAllReservations,
    getExternalPartnerSource,
  };
}

@Injectable()
// @TODO add extra header where needed
export class MerchantService {
  constructor(private http: HttpClient) {
  }

  // exportCustomers(merchantId) {
  //   return this.http.get(RESOURCES.MERCHANT + '/' + merchantId + '/customers_csv', {
  //     headers: {
  //       'Accept': 'text/csv'
  //     }
  //   });
  // }

  // importCustomers(merchantId, file) {
  //   var fd = new FormData();
  //   fd.append('attachment', file);
  //   return this.http.post(RESOURCES.MERCHANT + '/' + merchantId + '/import_csv', fd, {
  //     transformRequest: angular.identity,
  //     headers: {
  //       'Content-Type': undefined
  //     }
  //   });
  // }

  getMerchantById(merchantId) {
    return this.http.get(RESOURCES.MERCHANT + '/' + merchantId);
  }

  getMerchantSetting(merchantId, settingAttributeId) {
    return this.http.get(RESOURCES.MERCHANT + '/' + merchantId + '/settings?settingAttributeIds=' + settingAttributeId);
  }

  getMerchants(params): Observable<any> {
    return this.http.get(RESOURCES.MERCHANT, { params: params });
  }

  updateMerchantStatus(merchantId, data) {
    return this.http.put(RESOURCES.MERCHANT + '/' + merchantId + '/status', data);
  }

  deleteAreaById(merchantId, areaId) {
    return this.http.delete(RESOURCES.MERCHANT + '/' + merchantId + '/areas/' + areaId);
  }

  updateMerchant(id, data) {
    return this.http.put(RESOURCES.MERCHANT + '/' + id, data);
  }

  getMerchantProducts(id) {
    return this.http.get(RESOURCES.MERCHANT + '/' + id + '/products');
  }

  addMerchant(params) {
    return this.http.post(RESOURCES.MERCHANT, params);
  }

  triggerReindex(id) {
    return this.http.put(RESOURCES.MERCHANT + '/' + id + '/reindex_availabilities', null);
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/merchant.service.ts